import React from "react";

const CopyFromIcon: (props: React.SVGProps<SVGSVGElement>) => JSX.Element = ({
  height = "18px",
  width = "18px",
  ...props
}: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.65116 12.9767H3.49953C1.24744 12.9767 0 11.7377 0 9.47721V3.49953C0 1.24744 1.23907 0 3.49953 0H7.32558C9.57767 0 10.8251 1.23907 10.8251 3.49953C10.8251 3.84279 10.5405 4.12744 10.1972 4.12744C9.85395 4.12744 9.5693 3.84279 9.5693 3.49953C9.5693 1.92558 8.89954 1.25581 7.32558 1.25581H3.49953C1.92558 1.25581 1.25581 1.92558 1.25581 3.49953V9.47721C1.25581 11.0512 1.92558 11.7209 3.49953 11.7209H5.65116C5.99442 11.7209 6.27907 12.0056 6.27907 12.3488C6.27907 12.6921 5.99442 12.9767 5.65116 12.9767Z"
        fill="currentColor"
      />
      <path
        d="M14.5005 18H10.6744C8.42233 18 7.17488 16.7609 7.17488 14.5005V8.52279C7.17488 6.2707 8.41395 5.02326 10.6744 5.02326H14.5005C16.7526 5.02326 18 6.26233 18 8.52279V14.5005C18 16.7609 16.7609 18 14.5005 18ZM10.6744 6.27907C9.10046 6.27907 8.4307 6.94884 8.4307 8.52279V14.5005C8.4307 16.0744 9.10046 16.7442 10.6744 16.7442H14.5005C16.0744 16.7442 16.7442 16.0744 16.7442 14.5005V8.52279C16.7442 6.94884 16.0744 6.27907 14.5005 6.27907H10.6744Z"
        fill="currentColor"
      />
      <path
        d="M14.1321 12.1395H11.4112C11.0679 12.1395 10.7833 11.8549 10.7833 11.5116C10.7833 11.1684 11.0679 10.8837 11.4112 10.8837H14.1321C14.4753 10.8837 14.76 11.1684 14.76 11.5116C14.76 11.8549 14.4753 12.1395 14.1321 12.1395Z"
        fill="currentColor"
      />
      <path
        d="M12.7674 13.5042C12.4242 13.5042 12.1395 13.2195 12.1395 12.8763V10.1553C12.1395 9.81209 12.4242 9.52744 12.7674 9.52744C13.1107 9.52744 13.3953 9.81209 13.3953 10.1553V12.8763C13.3953 13.2195 13.1107 13.5042 12.7674 13.5042Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default CopyFromIcon;
